// TODO: try to replace with https://unpoly.com/closing-overlays#closing-after-the-submission-request

up.compiler('[close-modal-after-submit]', (element) => {

  element.addEventListener('click', function() {
    element.closest('form').submit()
    up.layer.dismiss()
  })

})
